document.addEventListener('DOMContentLoaded', function () {
  var GIFT_PROPERTY = '_AALIS Site Gift';
  var moneyFormatter = null;
  try {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    moneyFormatter = new Intl.NumberFormat(document.documentElement.lang || 'el-GR', {
      style: 'currency',
      currency: currency,
    });
  } catch (e) {
    moneyFormatter = null;
  }

  function formatMoney(cents) {
    var amount = cents / 100;
    if (moneyFormatter) return moneyFormatter.format(amount);
    return '€' + amount.toFixed(2).replace('.', ',');
  }

  function isEnglish() {
    return (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  }

  function lockedMessage(remainingCents) {
    var amount = formatMoney(remainingCents);
    return isEnglish()
      ? "You're " + amount + ' away from unlocking your gift.'
      : 'Χρειάζεσαι ακόμη ' + amount + ' για να ξεκλειδώσεις το δώρο σου.';
  }

  function setState(root, which) {
    var lockedEl = root.querySelector('[data-agp-locked]');
    var unlockedEl = root.querySelector('[data-agp-unlocked]');
    var confirmedEl = root.querySelector('[data-agp-confirmed]');
    if (lockedEl) lockedEl.hidden = which !== 'locked';
    if (unlockedEl) unlockedEl.hidden = which !== 'unlocked';
    if (confirmedEl) confirmedEl.hidden = which !== 'confirmed';
  }

  function renderRoot(root, cart) {
    var threshold = parseInt(root.getAttribute('data-threshold'), 10) || 11000;
    var lockedEl = root.querySelector('[data-agp-locked]');
    var barEl = root.querySelector('[data-agp-bar]');
    var lockedTextEl = root.querySelector('[data-agp-locked-text]');

    var hasGift = cart.items.some(function (item) {
      return item.properties && item.properties[GIFT_PROPERTY];
    });

    var wasLocked = root.hidden || (lockedEl && !lockedEl.hidden);

    root.hidden = false;

    if (hasGift) {
      setState(root, 'confirmed');
      return;
    }

    if (cart.total_price >= threshold) {
      setState(root, 'unlocked');
      if (wasLocked) {
        document.dispatchEvent(new CustomEvent('aalis:gift-unlocked', { detail: { cart: cart } }));
      }
      return;
    }

    var remaining = threshold - cart.total_price;
    var pct = Math.max(0, Math.min(100, Math.round((cart.total_price / threshold) * 100)));
    if (barEl) barEl.style.width = pct + '%';
    if (lockedTextEl) lockedTextEl.textContent = lockedMessage(remaining);
    setState(root, 'locked');
  }

  function refreshAll() {
    var roots = document.querySelectorAll('[data-agp-root]');
    if (!roots.length) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        roots.forEach(function (root) { renderRoot(root, cart); });
      })
      .catch(function (err) { console.error('[aalis-gift-progress]', err); });
  }

  function wireAddButtons() {
    document.querySelectorAll('[data-agp-root]').forEach(function (root) {
      var grid = root.querySelector('[data-agp-grid]');
      var addBtn = root.querySelector('[data-agp-add]');
      if (!grid || !addBtn || addBtn.dataset.agpWired) return;
      addBtn.dataset.agpWired = 'true';

      grid.addEventListener('change', function (evt) {
        if (!evt.target.classList.contains('agp-radio')) return;
        grid.querySelectorAll('.agp-card').forEach(function (card) {
          var radio = card.querySelector('.agp-radio');
          card.classList.toggle('is-selected', !!(radio && radio.checked));
        });
        addBtn.disabled = false;
      });

      addBtn.addEventListener('click', function () {
        var checked = grid.querySelector('.agp-radio:checked');
        if (!checked) return;
        addBtn.classList.add('is-loading');
        addBtn.setAttribute('aria-busy', 'true');

        var properties = {};
        properties[GIFT_PROPERTY] = 'Complimentary';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(checked.value), quantity: 1, properties: properties }] }),
        })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (err) { throw err; });
            return res.json();
          })
          .then(function () {
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'aalis-gift-progress' });
            }
            refreshAll();
          })
          .catch(function (err) {
            console.error('[aalis-gift-progress] add failed', err);
            refreshAll();
          })
          .finally(function () {
            addBtn.classList.remove('is-loading');
            addBtn.removeAttribute('aria-busy');
          });
      });
    });
  }

  wireAddButtons();
  refreshAll();

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'aalis-gift-progress') return;
      refreshAll();
      wireAddButtons();
    });
  }
});
